var React = require('react');

function Edge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.303 9.356a9.59 9.59 0 0 0-.165-.227C37.055 3.587 30.538 0 23.196 0 11.322 0 1.606 9.383.853 21.242c1.81-3.33 10.071-12.12 21.044-12.12 10.972 0 9.95 10.314 9.95 10.314h-17.19c.318-4.062 3.257-7.535 3.257-7.535C5.768 16.824 6.313 29.237 6.313 29.237c.296 5.801 2.202 9.812 4.737 12.583 6.003 6.563 15.527 6.176 15.527 6.176 8.576 0 14.357-3.445 14.357-3.445V34.495s-4.968 3.486-13.13 3.622c-13.608-.272-12.951-10.24-12.951-10.24h30.156v-5.341s.27-7.582-3.706-13.18z","fill":"#0278D7","fillRule":"evenodd"}));
}

Edge.defaultProps = {"width":"50","height":"50"};

module.exports = Edge;

Edge.default = Edge;
